export default "__VITE_ASSET__BAYgFVNj__"